.content {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}

.voice {
  margin: 0;
  padding: 0;
  border: 0;
  min-width: 0;
}

.legend {
  padding: 0;
  margin-bottom: var(--tuna-spacing-1);
  font-size: var(--tuna-typography-fontSize-sm);
  font-weight: 600;
  color: var(--tuna-content-primary);
}

/* Each row is at least 44px tall, a comfortable target on a phone (Joni §6) */
.voiceOption {
  display: flex;
  align-items: flex-start;
  gap: var(--tuna-spacing-1);
  min-height: 44px;
  cursor: pointer;
}

.voiceText {
  display: flex;
  flex-direction: column;
  padding-top: calc(var(--tuna-spacing-1) / 2);
}

.voiceLabel {
  color: var(--tuna-content-primary);
}

.voiceDescription {
  font-size: var(--tuna-typography-fontSize-sm);
  color: var(--tuna-content-secondary);
}

.instructions {
  display: flex;
  flex-direction: column;
}

.instructionsFooter {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--tuna-spacing-1);
  margin-top: calc(var(--tuna-spacing-1) / 2);
}

.helper,
.helperError {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-sm);
}

.helper {
  color: var(--tuna-content-secondary);
}

.helperError,
.counterError {
  color: var(--tuna-palette-error-main);
}

.counter,
.counterError {
  flex-shrink: 0;
  font-size: var(--tuna-typography-fontSize-sm);
  font-variant-numeric: tabular-nums;
}

.counter {
  color: var(--tuna-content-muted);
}

.conflictActions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-1);
  margin-top: var(--tuna-spacing-1);
}

.footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--tuna-spacing-1);
  /* The footer stays reachable above the phone keyboard in the full-screen dialog (Joni §6) */
  position: sticky;
  bottom: 0;
  background: var(--tuna-palette-background-paper);
}

.scope {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-sm);
  color: var(--tuna-content-secondary);
}

.actions {
  display: flex;
  gap: var(--tuna-spacing-1);
  margin-left: auto;
}

/* Read by screen readers, not shown: the length announcements */
.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}
